import { RuntimeModel, http } from '@kunlun/dependencies';

export const fetchPlanList = async (
  rModel: RuntimeModel,
  params: { sellerPartnerId: string; buyerPartnerId: string; planSearchKey: string; bizType: string }
) => {
  const gql = `
    mutation {
      sellerDistributionCreateOrderParamMutation{
        fetchPlans(createOrderParam: {
          sellerPartnerId: ${params.sellerPartnerId}
          buyerPartnerId: ${params.buyerPartnerId}
          bizType: ${params.bizType}
          planSearchKey: "${params.planSearchKey || ''}"
        }){
          id
          code
          name
          planRuleId
        }
      }
    }
  `;

  const res = await http.mutate<{ id: string; name: string; code: string; planRuleId: string }[]>(
    rModel.moduleName,
    gql
  );
  return res.data.sellerDistributionCreateOrderParamMutation.fetchPlans;
};
